"use client";

import React from "react";
import { MapPin, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const locations = [{
  city: "Central London",
  description: "Financial District & West End"
}, {
  city: "Canary Wharf",
  description: "Corporate & Executive Hub"
}, {
  city: "Manchester",
  description: "City Centre & MediaCityUK"
}, {
  city: "Birmingham",
  description: "Colmore Business District"
}, {
  city: "Edinburgh",
  description: "New Town & Financial Sector"
}];
export default function OurServiceAreas() {
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="our-service-areas" className="relative w-full min-h-[100svh] md:min-h-[800px] flex flex-col justify-end md:justify-center bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 bg-muted">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692125/img/grayscale_uk_map_bg.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692125/img/grayscale_uk_map_bg.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692125/img/grayscale_uk_map_bg.png-wvc-sizes" alt="Map showing Praise Space service areas" className="w-full h-full object-cover grayscale opacity-40 mix-blend-multiply" loading="lazy" />
        {}
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692125/img/noise_texture.png)] opacity-5 pointer-events-none mix-blend-overlay"></div>
      </div>

      {}
      <div className="absolute left-0 top-0 bottom-0 w-12 border-r border-border/50 bg-background/80 backdrop-blur-sm z-10 hidden md:flex flex-col items-center justify-center overflow-hidden">
        <div className="rotate-180 whitespace-nowrap" style={{
        writingMode: "vertical-rl"
      }}>
          <span className="font-mono text-[10px] font-semibold tracking-[0.15em] uppercase text-muted-foreground">
            Locations • Prime Areas • Sanctuary • Locations • Prime Areas • Sanctuary
          </span>
        </div>
      </div>

      {}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex justify-end pb-12 md:pb-0 pt-24 md:pt-0">
        <div ref={cardRef} className={`w-full md:w-[420px] transition-all duration-1000 ease-[cubic-bezier(0.16,1,0.3,1)] ${isCardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Card className="bg-foreground text-background rounded-md shadow-2xl border-none overflow-hidden group">
            {}
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-secondary scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>

            <CardHeader className="pt-10 pb-6 px-8 md:px-10">
              <h2 className="font-default text-[clamp(2rem,5vw,3rem)] font-normal tracking-tight leading-[1.1]">
                <span className="block ml-8 text-secondary transition-transform duration-700 group-hover:translate-x-2">
                  Prime
                </span>
                <span className="block">Locations</span>
              </h2>
            </CardHeader>

            <CardContent className="px-8 md:px-10 pb-8 flex flex-col gap-6">
              <div className="w-full h-px bg-background/10 mb-2"></div>
              
              <ul className="flex flex-col gap-5">
                {locations.map((location, i) => <li key={i} data-index={i} className="flex items-start gap-4 group/item cursor-default">
                    <div className="mt-2 size-2 shrink-0 bg-secondary rounded-lg transition-transform duration-300 group-hover/item:scale-150"></div>
                    <div className="flex flex-col">
                      <span className="font-sans text-lg font-medium text-background tracking-wide">
                        {location.city}
                      </span>
                      <span className="font-sans text-sm font-light text-background/60 mt-0.5">
                        {location.description}
                      </span>
                    </div>
                  </li>)}
              </ul>
            </CardContent>

            <CardFooter className="px-8 md:px-10 pb-10 pt-2">
              <Button asChild className="w-full bg-background text-foreground hover:bg-background/90 rounded-md h-14 text-base font-medium tracking-wide group/btn">
                <Link to="/ContactPage">
                  Enquire Availability
                  <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                </Link>
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}